module.exports = __webpack_public_path__ + "img/科技馆-小图.82fc8517.png";